import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {LoginApi} from '../../../apis/LoginApi/LoginApi.ts';
import { PostHogService } from '../../../services/posthogService.ts';

export function usePostLogout() {
    return useMutation<number, AppMedError>({
        mutationKey: [QueryKeys.login],
        mutationFn: async () => {
            return await LoginApi.logout();
        },
        onSuccess: () => {
            PostHogService.capture('user logged out');
            PostHogService.reset();
            localStorage.removeItem('currentUser');
            window.location.href = '/login';
        },
        onError: (error) => {
            console.error('Logout failed:', error.message);
        },
    });
}
